// File: frontend/src/index.tsx
import './styles/Variables.css';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n'; // Import your i18n configuration
import { BootSplash } from './components/common/BootSplash';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initAnalytics } from './utils/analytics';

// Google Analytics is initialized here, at startup, for every visitor.
//
// This is safe because public/index.html has already put Consent Mode into the
// fully denied default state before this file runs: the tag loads, but writes
// no cookie and stores no identifier until the visitor accepts. Loading it
// unconditionally is what makes non-consenting traffic countable at all —
// gating the injection itself, as we did before, erased those visitors from
// Analytics completely.
//
// CookieConsentContext then sends the actual decision via applyConsent().
initAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {/* BootSplash replaces the old hardcoded "Loading translations..." text.
        It is branded, localized without i18n (which has not loaded yet) and
        turns into a retry screen if the locale fetch never completes. */}
    <Suspense fallback={<BootSplash />}>
      <App />
    </Suspense>
  </React.StrictMode>
);

// PWA Ticket 1: makes the site installable and enables offline caching of the
// app shell. Push notifications (Ticket 2) are wired up separately in the
// settings page. Ticket 4: register() now also watches for a newer deployed
// service worker; the banner itself lives in UpdateAvailableBanner (App.tsx).
serviceWorkerRegistration.register();